var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpMethod } from '../enums/httpMethod';
import { Scope } from '../scope';
import { Filter } from '../filter';
import { Sorter } from '../sorter';
import { SortDirection } from '../enums/sortDirection';
import { UrlBuilder } from '../../../builders/urlBuilder';
import { Orion } from '../../../orion';
export class QueryBuilder {
    constructor(modelConstructor, baseUrl) {
        this.includes = [];
        this.fetchTrashed = false;
        this.fetchOnlyTrashed = false;
        this.scopes = [];
        this.filters = [];
        this.sorters = [];
        if (baseUrl) {
            this.baseUrl = baseUrl;
        }
        else {
            this.baseUrl = UrlBuilder.getResourceBaseUrl(modelConstructor);
        }
        this.modelConstructor = modelConstructor;
        this.httpClient = Orion.makeHttpClient(this.baseUrl);
    }
    get(limit = 15, page = 1) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpClient.request('', HttpMethod.GET, this.prepareQueryParams({ limit, page }));
            return response.data.data.map((attributes) => {
                return this.hydrate(attributes, response);
            });
        });
    }
    search(limit = 15, page = 1) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpClient.request('/search', HttpMethod.POST, this.prepareQueryParams({ limit, page }), {
                scopes: this.scopes,
                filters: this.filters,
                search: { value: this.searchValue },
                sort: this.sorters,
            });
            return response.data.data.map((attributes) => {
                return this.hydrate(attributes, response);
            });
        });
    }
    find(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpClient.request(`/${key}`, HttpMethod.GET, this.prepareQueryParams());
            return this.hydrate(response.data.data, response);
        });
    }
    store(attributes) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpClient.request('', HttpMethod.POST, this.prepareQueryParams(), attributes);
            return this.hydrate(response.data.data, response);
        });
    }
    update(key, attributes) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpClient.request(`/${key}`, HttpMethod.PATCH, this.prepareQueryParams(), attributes);
            return this.hydrate(response.data.data, response);
        });
    }
    destroy(key, force = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpClient.request(`/${key}`, HttpMethod.DELETE, this.prepareQueryParams({ force }));
            return this.hydrate(response.data.data, response);
        });
    }
    restore(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpClient.request(`/${key}/restore`, HttpMethod.POST, this.prepareQueryParams());
            return this.hydrate(response.data.data, response);
        });
    }
    with(relations) {
        this.includes = relations;
        return this;
    }
    withTrashed() {
        this.fetchTrashed = true;
        return this;
    }
    onlyTrashed() {
        this.fetchOnlyTrashed = true;
        return this;
    }
    scope(name, parameters = []) {
        this.scopes.push(new Scope(name, parameters));
        return this;
    }
    filter(field, operator, value, type) {
        this.filters.push(new Filter(field, operator, value, type));
        return this;
    }
    sortBy(field, direction = SortDirection.Asc) {
        this.sorters.push(new Sorter(field, direction));
        return this;
    }
    lookFor(value) {
        this.searchValue = value;
        return this;
    }
    hydrate(raw, response) {
        const model = new this.modelConstructor();
        for (const field of Object.keys(raw)) {
            const rawValue = raw[field];
            if (typeof model[field] === 'function') {
                const relationQueryBuilder = model[field]();
                if (Array.isArray(rawValue)) {
                    model.$relations[field] = rawValue.map((rawRelation) => {
                        return relationQueryBuilder.hydrate(rawRelation, response);
                    });
                }
                else {
                    if (rawValue) {
                        model.$relations[field] = relationQueryBuilder.hydrate(rawValue, response);
                    }
                    else {
                        model.$relations[field] = rawValue;
                    }
                }
            }
            else {
                model.$attributes[field] = rawValue;
            }
        }
        model.$response = response;
        return model;
    }
    prepareQueryParams(operationParams = {}) {
        if (this.fetchOnlyTrashed) {
            operationParams.only_trashed = true;
        }
        if (this.fetchTrashed) {
            operationParams.with_trashed = true;
        }
        if (this.includes.length > 0) {
            operationParams.include = this.includes.join(',');
        }
        return operationParams;
    }
}
//# sourceMappingURL=queryBuilder.js.map